import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { BaseComponent, number } from "../../../../../common/base-component";
import toast from "react-hot-toast";
import {
  fetchglobalCommision,
  updateGlobalCommission,
  updateProductglobalbearerunset,
} from "../../actions/index";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { classNames } from "../../../../../common/common-functions";
import AllGlobalTabsList from "../globaltabs";
import BaseLoader from "../../../../../common/base-loader";

class GlobalRefund extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      setOpen: false,
      btnLoader: false,
      loading: true,
      loaderDesc: "Preparing Global Refund",
    };
  }

  componentDidMount() {
    this.props.fetchglobalCommision(this.props.session, (CallBackResponse) => {
      this.setState({ loading: false });
    });
  }

  onFormSubmit = (values) => {
    // console.log("val", values);
    this.setState({ btnLoader: true });
    var data = {};
    if (values.isshippingcostbear == true) {
      data.isshippingcostbear = 1;
      data.id = values.id;
      this.props.updateGlobalCommission(
        this.props.session,
        data,
        (response) => {
          if (response.success === 0) {
            toast.error("Not updated");
            this.setState({ btnLoader: false });
          } else {
            NotificationManager.success("Successfully refund updated!");
            this.setState({ btnLoader: false });
            this.props.fetchglobalCommision(
              this.props.session,
              (CallBackResponse) => {}
            );
          }
        }
      );
    } else {
      data.isshippingcostbear = 0;
      data.id = values.id;
      this.props.updateProductglobalbearerunset(
        this.props.session,
        (response) => {
          // console.log('response:-->', response)
          if (response.success === 1) {
            this.props.updateGlobalCommission(
              this.props.session,
              data,
              (response) => {
                if (response.success === 0) {
                  toast.error("Not updated");
                  this.setState({ btnLoader: false });
                } else {
                  NotificationManager.success("Successfully refund updated!");
                  this.setState({ btnLoader: false });
                  this.props.fetchSeller(
                    this.props.session,
                    0,
                    (CallBackResponse) => {}
                  );
                }
              }
            );
          } else {
            toast.error("Not updated");
          }
        }
      );
    }
  };

  render() {
    var { data, handleSubmit, initialValues } = this.props;
    // console.log("valuesdatarender", this.props.session);

    return (
      <>
        <AllGlobalTabsList history={this.props.history} />
        {this.state.loading ? (
          <>
            <BaseLoader data={this.state.loaderDesc} />
          </>
        ) : (
          <>
            <div className="">
              <form className=" " onSubmit={handleSubmit(this.onFormSubmit)}>
                <div className="flow-root px-10 py-5 bg-custWhite rounded m-6">
                  <p className="mb-3 center-item" style={{ fontSize: "20px" }}>
                    Global Refund For Seller
                  </p>
                  <div className="mt-5 center-item">
                    <Field
                      name="isshippingcostbear"
                      label="Refund By Shopez"
                      component={this.renderFieldCheckbox}
                      type="checkbox"
                      className="cust-check-box"
                      classNameLabel="text-box-lable"
                    />
                  </div>

                  <div className="center-item my-16">
                    <button type="submit" className="bigbutton">
                      <svg
                        className={classNames(
                          this.state.btnLoader ? "" : "sr-only",
                          "animate-spin-medium h-5 w-5 rounded-full mx-2"
                        )}
                        viewBox="0 0 1024 1024"
                        focusable="false"
                        data-icon="loading"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        aria-hidden="true">
                        <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                      </svg>
                      Submit
                    </button>
                  </div>
                </div>
              </form>
              <NotificationContainer />
            </div>
          </>
        )}
      </>
    );
  }
}

function validate(val) {
  // console.log("form data", values);
  var errors = {};
  var commission_perrefund = val["commission_perrefund"];
  var commission_perorder = val["commission_perorder"];
  if (commission_perrefund && number(commission_perrefund)) {
    errors["commission_perrefund"] = "Please enter a number";
  }
  if (commission_perorder && number(commission_perorder)) {
    errors["commission_perorder"] = "Please enter a number ";
  }
  return errors;
}

function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
    // initialValues: state.global_commissionlist.data,
    initialValues: state.global_commissionlist
      ? state.global_commissionlist.data
      : [],
  };
}

export default connect(mapStateToProps, {
  fetchglobalCommision,
  updateGlobalCommission,
  updateProductglobalbearerunset,
})(
  reduxForm({
    validate,
    form: "GlobalCommissionForm2",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(GlobalRefund)
);
